import { on_ready, is_elementor_edit } from 'js/utils';
import { init_retina } from 'js/retina';
import { init_toggle_height } from 'js/toggle_height_init';

import { init_header } from 'modules/header/header';
import init_forms from 'modules/forms/forms';
import init_carousels from 'modules/carousel/carousel';
import init_footer from 'modules/footer/footer';
import init_nav_menu from 'modules/menu/nav/nav';

// load global styles
import './main.scss';

// if( import.meta.hot ) {
//     import.meta.hot.accept(); 
// }

on_ready(()=>{

    init_footer();

    if( is_elementor_edit() ) return;
    
    // forms ui + gravityforms customizations
    // move outside of tasks queue, have issues with hooks registered late
    init_forms();

    init_header();

    init_nav_menu();

    init_carousels(); // swiper

    init_retina(); // @images

    init_toggle_height(); // toggle element height from 0 to default - for animating height

    banner_slide_alt_text();

    closed_accordion_mobile();

    on_mobile();
    
    init_dynamic_load();
    
    document.dispatchEvent(new Event('after_main_init'));
});

function on_mobile(){
    if( window.innerWidth > 768 ) return;

    close_footer_dropdowns();
    // closed_accordion_mobile();

    setTimeout(() => {
        close_footer_dropdowns();
    }, 300);

}

function init_dynamic_load(){

    // search popup: remove if not used
    if( document.querySelector('.search_popup_open') ) {
        import('modules/search/search_popup/init');
    }
    
    // burger / mobile menu: remove if not used
    if( document.querySelector('.slide_menu_open') ) {
        import('modules/menu/slide_menu/init');
    }

    // wishlist & compare: remove if not used
    // if( document.querySelector('.compare_count') ||
    //     document.querySelector('.wishlist_count') ) {
    //     import('modules/save_items/init');
    // }
    
    // cookie consent
    // if( !get_cookie('ff_cookie_consent') ) {
    //     import('modules/cookie_consent/simple/simple')
    // }
}

function  banner_slide_alt_text() {
    const banners = document.querySelectorAll('.banner_carousel.ff-swiper');
    if (!banners.length) return;

    banners.forEach((banner) => {
        
        const checkSwiper = setInterval(() => {
            if (banner.swiper) {
                clearInterval(checkSwiper);
                const swiperInstance = banner.swiper;
                const altContainer = banner.querySelector('.banner-alt-container');
                if (!altContainer) return;

                function updateAltText() {
                    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
                    const altTextEl = activeSlide.querySelector('.banner-alt-text');
                    altContainer.textContent = altTextEl ? altTextEl.textContent : '';
                }

                updateAltText();

                swiperInstance.on('slideChange', updateAltText);
            }
        }, 50); 
    });
}

function close_footer_dropdowns(){
    document.querySelectorAll('.elementor-location-footer .ff_toggle_height_trigger.open').forEach(dropdown=>{
        dropdown.click();
    })
}

function closed_accordion_mobile() {
    // const is_mobile = window.innerWidth < 768;
    
    // if (!is_mobile) return;

    const delay = 100;
    setTimeout(() => {
        jQuery('.e-n-accordion-item').removeAttr('open');
    }, delay);
}
